module.exports = __webpack_public_path__ + "static/media/204-Kaffee_ID_13.db3c43c9.mp3";